import type { IBankExport, IBankExportDetail } from "entities/bankExport";
import { formatDateFilename } from "utils/localizations";
import InternalTransferExportDetailResponse from "entities/internalTransferExportDetailResponse";
import TransferRefundExportDetailResponse from "entities/transferRefundExportDetailResponse";
import TransferType from "entities/transferType";
import InternalTransferExportResponse from "entities/internalTransferExportResponse";
import TransferRefundExportResponse from "entities/transferRefundExportResponse";
import DistributorRefundExportResponse from "entities/distributorRefundExportResponse";
import DistributorRefundExportDetailResponse from "entities/distributorRefundExportDetailResponse";
import PayGateRefundExportResponse from "entities/payGateRefundExportResponse";
import PayGateRefundExportDetailResponse from "entities/payGateRefundExportDetailResponse";

export function getBankExportFilename(item: IBankExportDetail | IBankExport) {
  let type = "unknown";
  if (item instanceof TransferRefundExportDetailResponse || item instanceof TransferRefundExportResponse) {
    switch (item.refundType) {
      case TransferType.Domestic:
        type = "prt";
        break;
      case TransferType.Foreign:
        type = "prz";
        break;
      case TransferType.Sepa:
        type = "sepa";
        break;
      case TransferType.Unspecified:
        type = "unspecified";
        break;
    }
  } else if (item instanceof DistributorRefundExportResponse || item instanceof DistributorRefundExportDetailResponse) {
    type = "distributor";
  } else if (item instanceof InternalTransferExportResponse || item instanceof InternalTransferExportDetailResponse) {
    type = "prt";
  } else if (item instanceof PayGateRefundExportResponse || item instanceof PayGateRefundExportDetailResponse) {
    type = "platebni_brana";
  }

  return `exporty_${type}_${formatDateFilename(item.createdAt)}_${item.id}.zip`;
}
